import React from "react";
import { useObserver } from "mobx-react-lite";
import { useHistory } from "react-router";
import { Paper, TextField, Button, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { grey, red } from "@material-ui/core/colors";
import { useAuthStore } from "stores/AuthStore";
import { StoreProvider, useStore } from "./Store";

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundColor: grey[50],
  },
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
  },
  card: {
    textAlign: "center",
    margin: theme.spacing(6, 0, 0, 0),
    padding: theme.spacing(3),
  },
  logo: {
    width: "80%",
  },
  button: {
    marginTop: theme.spacing(3),
  },
  error: {
    color: red[900],
    backgroundColor: red[50],
    padding: theme.spacing(1),
    marginBottom: theme.spacing(3),
    borderRadius: "4px",
  },
}));

export const Page = () => {
  const authStore = useAuthStore();
  const store = useStore();
  const history = useHistory();
  const styles = useStyles();

  const handleLoginId = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      store.value.loginId = e.target.value;
    },
    [store]
  );

  const handlePassword = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      store.value.password = e.target.value;
    },
    [store]
  );

  const signIn = React.useCallback(async () => {
    const accessToken = await store.accessToken();
    if (accessToken) {
      authStore.signIn(accessToken);
      history.replace("/");
    }
  }, [authStore, history, store]);

  const onEnterKeyPress = React.useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        signIn();
      }
    },
    [signIn]
  );

  return useObserver(() => (
    <main className={styles.background}>
      <Container className={styles.container} maxWidth="xs">
        <Paper className={styles.card}>
          <img
            className={styles.logo}
            alt="Logo"
            src="logo/layapp-title-1000x300.png"
          />

          {store.errors.messages && store.errors.messages.length > 0 && (
            <div className={styles.error}>{store.errors.messages}</div>
          )}

          <TextField
            fullWidth
            margin="normal"
            label="ログインID"
            error={!!store.errors.columns.loginId}
            helperText={store.errors.columns.loginId}
            onChange={handleLoginId}
            onKeyPress={onEnterKeyPress}
          />

          <TextField
            fullWidth
            margin="normal"
            type="password"
            label="パスワード"
            error={!!store.errors.columns.password}
            helperText={store.errors.columns.password}
            onChange={handlePassword}
            onKeyPress={onEnterKeyPress}
          />

          <Button
            className={styles.button}
            fullWidth
            variant="contained"
            color="primary"
            disabled={store.loading}
            onClick={signIn}
          >
            ログイン
          </Button>
        </Paper>
      </Container>
    </main>
  ));
};

export default () => (
  <StoreProvider>
    <Page />
  </StoreProvider>
);
